/// <reference path="../types/index.d.ts" />

import '../client_forms/culinaryteam3/style.css';
import FormStructure from './culinaryteam3/form_structure';

export default FormStructure;